module.exports = __webpack_public_path__ + "img/AfCFTA.cabe69a0.png";